<template>
  <div>
    <table class="base-stream-reference">
      <caption>{{ $t('common.productList') }}</caption>
      <thead>
        <th v-for="th in tableInfo.th" :key="th.value">{{ th.value }}</th>
      </thead>
      <tbody>
        <tr v-for="td in tableInfo.td" :key="td.name">
          <td>{{ td.name }}</td>
          <td class="stream">{{ td.num }}</td>
          <td class="stream">{{ td.unit }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'productionTable',
  props: {
    tableInfo: {}
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';
table.base-stream-reference {
  width: 100%;
  border: 1px solid #{$color-border1};
  border-top: none;
  border-collapse: collapse;
  vertical-align: middle;
}
caption {
  padding-top: 22px;
  padding-bottom: 22px;
  border: 1px solid #{$color-border1};
  border-bottom: none;
  font-size: $font-size-normal;
  font-weight: $font-bold;
  color: $reference-table-color;
  background: #e6e6e6;
}
th,
td {
  text-align: center;
  color: $reference-table-color;
}
th {
  padding: 15px 10px 15px 10px;
  font-size: $font-size-form;
  font-weight: $font-bold;
  background: $color-bg-main;
  width: 33%;
}
th:first-child {
  text-align: left;
}
td {
  padding: 10px 10px 10px 10px;
  font-size: $font-size-form;
  line-height: 1.2;
  &.stream {
    text-align: center;
  }
}
td:first-child {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/productionTable/index.vue